package ru.villawonka.app.data.entity.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ErrorResponse(
    @SerialName("status") val status: Int,
    @SerialName("error") val error: String,
)